<template>
  <div class="newsInformation">
    <detailsTop />
    <div class="news-content">
      <div class="new-left"></div>
      <div class="new-center">
        <div class="new-list">
          <div
            style="width: 100%; padding-left: 3%; cursor: pointer"
            v-for="(item, index) in newList"
            :key="index"
          >
            <div class="newList-wrap" @click="jumpPage(item)">
              <el-image
                lazy
                class="newList-wrap-left"
                :src="baseURL + item.cover"
              ></el-image>

              <div class="newList-wrap-right">
                <div class="newList-wrap-right-title">
                  {{ item.title }}
                </div>
                <div class="newList-wrap-right-content">
                  {{ item.industry }}
                </div>
                <div>
                  <span style="color: #b5b5b5">{{ item.createTime }}</span
                  ><span style="color: #666666; margin-left: 19px"
                    >{{ item.views }} 阅读</span
                  >
                </div>
              </div>
            </div>
            <div class="newList-line"></div>
          </div>
        </div>

        <div class="pagination">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            prev-text="上一页"
            next-text="下一页"
            :current-page.sync="page"
            :page-size="size"
            layout="prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
      <div class="new-right"></div>
    </div>

    <pageBottom />
  </div>
</template>

<script>
import detailsTop from "@/components/detailsTop.vue";
import pageBottom from "@/components/pageBottom";
import { selectTEnterpriseNewsPage, selectTNewsPage } from "@/api/api.js";

export default {
  name: "news1",
  components: {
    detailsTop,
    pageBottom,
  },
  data() {
    return {
      bannerTipsList: [],
      page: 1,
      size: 10,
      total: null,
      newList: [],
      type: "",
      searchInput: "",
    };
  },
  created() {
    this.type = this.$route.query.type;
    this.searchInput = this.$route.query.search;

    if (this.type == "service") {
      this.getData();
    }
    if (this.type == "search") {
      this.getSearchData();
    }
  },
  mounted() {},
  methods: {
    bannerIndexClick(index) {
      // this.bannerIndex = index
    },

    async getData() {
      var params = {
        page: this.page,
        size: this.size,
      };
      const { data } = await selectTEnterpriseNewsPage(params);
      if (data.code === 200) {
        this.newList = data.data.list;
        this.total = data.data.total;
      }
    },
    async getSearchData() {
      let listContent = document.getElementsByClassName("new-list");
      var params = {
        page: this.page,
        size: this.size,
        likeName: this.searchInput,
      };
      const { data } = await selectTNewsPage(params);
      if (data.code === 200) {
        this.newList = data.data.list;
        if (this.newList.length == 0) {
          listContent[0].innerHTML = "暂未找到你想看的内容...";
          listContent[0].style.fontSize = "20px";
        }
        this.total = data.data.total;
      }
    },
    jumpPage(item) {
      if (this.type == "search") {
        const routeUrl = this.$router.resolve({
          path: "/publicDetails",
          query: {
            newsId: item.newsId,
            projectTypeParentId: item.projectTypeParentId,
            type: "search",
          },
        });
        window.open(routeUrl.href, "_blank");
      }
      if (this.type == "service") {
        const routeUrl = this.$router.resolve({ 
          path: "/publicDetails",
          query: { enterpriseNewsId: item.enterpriseNewsId, type: "service" },
        });
        window.open(routeUrl.href, "_blank");
      }
    },

    handleCurrentChange(val) {
      this.page = val;
      if (this.type == "search") {
        this.getSearchData();
      }
      if (this.type == "service") {
        this.getData();
      }
    },
  },
};
</script>

<style scoped lang="less">
.news-content {
  margin-top: 20px;
  width: 100%;
  height: 100%;
  display: flex;

  .new-left {
    flex: 1;
  }

  .new-center {
    flex: 5.3;
    background: #f4f4f4;
    min-height: 500px;
    .new-list {
      margin-top: 22px;
      background: #ffffff;
      width: 100%;
      min-height: 50px;
      padding-top: 2%;

      .newList-wrap {
        display: flex;
        justify-content: space-between;

        .newList-wrap-left {
          width: 276px;
          height: 130px;
          border-radius: 4px;
        }

        .newList-wrap-right {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          text-align: left;
          margin-left: 1.6%;
          margin-right: 4%;
          width: 95%;

          .newList-wrap-right-title {
            width: 900px;
            color: #333333;
            font-size: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .newList-wrap-right-content {
            width: 95%;
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
      }

      .newList-line {
        height: 1px;
        background: #eeeeee;
        margin: 1.8% 0;
        margin-right: 7%;
      }
    }

    .pagination {
      margin: 4% auto;
    }
  }

  .new-right {
    flex: 1;
    // background: sandybrown;
  }
  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #46739f;
    color: #fff;
  }
}

@media only screen and (max-width: 1550px) {
  .new-left {
    flex: 1 !important;
  }

  .new-center {
    flex: 12 !important;
    background: #f4f4f4;
  }

  .new-right {
    flex: 1 !important;
  }
}
</style>
